// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyFunction = (...args: any[]) => unknown

export function debounce<F extends AnyFunction>(fn: F, delay: number) {
  let t: number | undefined = undefined
  return (...args: Parameters<F>) => {
    clearTimeout(t)
    t = setTimeout(() => {
      fn(...args)
    }, delay) as unknown as number
  }
}
